<ng-container *ngIf="content && content.promobannerEnabled">

    <div *ifSize="'XL'"
         class="center"
         [ngClass]="[content.promobannerColor || 'col-w', content.promobannerBackround || 'bg-col-6']"
         [style.padding]="'9px 44px'">
        <href class="flex flex-middle flex-justify-between"
              [style.gap.px]="8"
              [link]="content.promobannerLink">
            <!-- advanced content -->
            <ng-container *ngFor="let block of content.promobannerBlocks">
                <!-- icon with text block -->
                <div class="w-12 ">
                    <href [link]="block.link">
                        <span class="m-r-2"
                              [lineHeightBy]="'p2'">
                            <i [style.font-size.px]="16"
                               [ngClass]="block.icon"></i>
                        </span>
                    </href>
                    <span class="p2"
                          *iCms="'copy' of block; content 'html'"></span>
                </div>
            </ng-container>
        </href>
    </div>

    <div *ifSize="'MS'"
         class="center _carousel flex flex-middle"
         [ngClass]="[content.promobannerColor || 'col-w', content.promobannerBackround || 'bg-col-6']">
        @if(isPlatformBrowser) {
        <swiper class="pos-relative default-swiper"
                [loop]="true"
                [autoplay]="{delay: 3000}"
                [slidesPerView]="'auto'"
                [style.--pc-slides-ceil]="pcSlidesCeil"
                [style.--pc-slides]="pcSlides"
                [style.--pc-slides-gap]="pcSlidesGap">
            <ng-container *ngFor="let block of content.promobannerBlocks">
                <!-- icon with text block -->
                <ng-template swiperSlide>
                    <href [link]="block.link"
                          class="flex flex-middle flex-justify-center">
                        <i class="m-r-2"
                           [style.font-size.px]="24"
                           [ngClass]="block.icon"></i>
                        <span class="p2 _slideCopy"
                              *iCms="'copy' of block; content 'html'"></span>
                    </href>
                </ng-template>
            </ng-container>
        </swiper>
        }
    </div>


</ng-container>
